export default function Offers() {
  return (
    <section className="sales-layout__page">
      <h1>Angebote</h1>
      <p>Die Angebote sind in Vorbereitung.</p>
    </section>
  );
}
